import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'g10-route-rostering-layout',
  templateUrl: './route-rostering-layout.component.html',
  styleUrls: ['./route-rostering-layout.component.css']
})
export class RouteRosteringLayoutComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
